import { Box, Checkbox, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import wallet_illustration from '../../assets/coin-wallet-illustration.svg';

export const LeadGenerationBanner = () => {
  const { sessionData, updateMembershipForm } = useContext(MembershipAppStateContext);

  const saveGenerateAutoLead = (generateAutoLead: boolean) => {
    const updatedFormData = {
      ...sessionData.formData,
      generateAutoLead,
    };
    updateMembershipForm(updatedFormData);
  };

  return (
    <Stack
      direction="row"
      sx={{
        backgroundColor: '#FAF8F4',
        borderRadius: '10px',
        marginBottom: '1.5rem',
        width: '100%',
        '& .MuiFormControlLabel-root': { width: '100% !important', padding: '16px 0 16px 8px !important' },
      }}
    >
      <Checkbox
        variant="text"
        name="generateAutoLead"
        className="generateAutoLead"
        id="generateLead-checkbox"
        label={
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="b2Regular" alignSelf="start">
              Your AAA membership unlocks exclusive auto insurance savings — get your quote now.
            </Typography>
          </Stack>
        }
        sx={{ padding: '1rem', width: '100%' }}
        fullWidth
        checked={sessionData.formData.generateAutoLead ?? false}
        onClick={(mouseEvent) => {
          const target = mouseEvent.target as HTMLInputElement;
          saveGenerateAutoLead(target.checked);
        }}
      />
      <Box sx={{ padding: '7px 21px 7px 8px' }}>
        {' '}
        <img src={wallet_illustration} alt="Auto Insurance Lead Gen" style={{ width: '66px' }} />
      </Box>
    </Stack>
  );
};
